import React from "react";

const LoadingBook = ({
  setGotoConfrimAuthor,
  setSupportModel,
  setThanksModel,
  setLoadingBook,
  setTroubleModel,
}) => {
  return (
    <div
      className="modal custom_background custom_modal_create"
      id="confirm_authors"
      tabIndex="-1"
      style={{ display: "block" }}
      aria-labelledby="confirm_authorsLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body-cre">
            <h4>loading book...</h4>
            <p>
              Thank you for your patience while you wait for your book to be
              uploaded to greyled
              <span
                className="create-colo"
                onClick={() => {
                  setTroubleModel(true);
                  setLoadingBook(false);
                  setThanksModel(false);
                }}
              >
                create
              </span>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingBook;
